import { Injectable } from '@angular/core';
import { BaseService } from './base.service';
import { HttpClient } from '@angular/common/http';
import { lastValueFrom } from 'rxjs';
import { Contract } from '@cl/shared/models/contract.model';

@Injectable({
    providedIn: 'root',
})
export class ContractsService extends BaseService<Contract> {
    constructor(protected httpClient: HttpClient) {
        super(httpClient, '/api/v1/contracts/');
    }

    async addContractToScontract(contractId: number, scontractId: number): Promise<void> {
        return await lastValueFrom(this.httpClient.put<void>(`${this.baseApiUrl}add-to-scontract/${contractId}/${scontractId}`, null));
    }

    async removeContractFromScontract(contractId: number, scontractId: number): Promise<void> {
        return await lastValueFrom(this.httpClient.put<void>(`${this.baseApiUrl}remove-from-scontract/${contractId}/${scontractId}`, null));
    }

    toString(object: Contract): string {
        return object.number;
    }
}
